import "./Home.css";

import homebanner from "../../assets/img/Home-Banner/firstbanner.webp";
import homebannertwo from "../../assets/img/Home-Banner/banner-two.webp";
import homebannerthree from "../../assets/img/Home-Banner/banner-three.webp";

import mobileBanner1 from "../../assets/img/Home-Banner/firstbanner-mobile.webp";
import mobileBanner2 from "../../assets/img/Home-Banner/banner-two-mobile.webp";
import mobileBanner3 from "../../assets/img/Home-Banner/banner-three-mobile.webp";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import required modules
import VerifyCertificate from "../VerifyCertificate/VerifyCertificate";
export default function HomeBanner() {
  return (
    <>
      <section className="home-banner ">
        <Swiper
          navigation={true}
          pagination={true}
          modules={[Navigation, Pagination, Autoplay]}
          autoplay={{ delay: 2500, disableOnInteraction: true }}
          loop={true}
          className="mySwiper"
        >
          <SwiperSlide>
            <img
              src={window.innerWidth > 568 ? homebanner : mobileBanner1}
              alt="homebanner"
              className="img-fluid w-100"
            />
            <div className="banner-content">
              <h1 className="heading-one">
                Best Diamond Testing & Certification in India{" "}
              </h1>
              <h2 className="heading-two">
                {" "}
                Certified Diamond Testing you can trust
              </h2>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={window.innerWidth > 568 ? homebannertwo : mobileBanner2}
              alt="homebanner"
              className="img-fluid w-100"
            />
            <div className="banner-content">
              <h2 className="heading-one">
                Top Diamond Gemological Laboratory
              </h2>
              <h3 className="heading-two">
                {" "}
                Providing Guaranteed Authenticity of Grading
              </h3>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={window.innerWidth > 568 ? homebannerthree : mobileBanner3}
              alt="homebanner"
              className="img-fluid w-100"
            />
            <div className="banner-content">
              <h2 className="heading-one">Best Diamond Testing Lab</h2>
              <h3 className="heading-two">
                {" "}
                Sreehari's Trusted Diamond Testing Services
              </h3>
            </div>
          </SwiperSlide>
        </Swiper>
        <VerifyCertificate />
      </section>
    </>
  );
}
